import React from 'react';
import PropTypes from 'prop-types'
import {Box, Flex, Text} from "rebass";
import {minWidth} from "styled-system";
import styled from 'styled-components'

import {InlineBlock, Popover} from "reakit";

import IosArrowDown from "react-ionicons/lib/IosArrowDown";
import IosArrowUp from 'react-ionicons/lib/IosArrowUp'
import SelectInput from '../Forms/SelectInput'


const HeaderTitle = styled(Flex)`
	${minWidth}
`

const DropdownField = (props) => {
	const {showSelected, filterTitle, options, handleSelect,
		selected, filterType, titleWidth, titleFontSize} = props;
	return (
		<Popover.Container>
			{popover => (
				<InlineBlock relative>
					<HeaderTitle onClick={popover.toggle} minWidth={titleWidth} flexDirection={'row'}>
						<Text fontWeight={700} color={'black'} fontSize={titleFontSize} >{(showSelected && selected[0] !== undefined) ? selected[0] : filterTitle}</Text>
						<Box p={1}>
							{popover.visible ? <IosArrowUp  {...popover}/> :
								<IosArrowDown {...popover} />}

						</Box>
					</HeaderTitle>

					<Popover fade slide expand hideOnClickOutside {...popover} padding={0} margin={0} borderRadius={0} minWidth={'300px'}>
						{options.map(option =>
							<SelectInput key={option.value} type={filterType} label={option.label} value={option.value} selected={selected.includes(option.value)}  onChange={handleSelect}/>
						)}

					</Popover>
				</InlineBlock>
			)}
		</Popover.Container>

	);
};

DropdownField.propTypes = {
	showSelected: PropTypes.bool,
	filterTitle: PropTypes.string,
	filterType: PropTypes.string,
	handleSelect: PropTypes.func,
	selected: PropTypes.array,
	titleWidth: PropTypes.string,
	titleFontSize: PropTypes.number
};

DropdownField.defaultProps = {
	showSelected: false,
	filterTitle: "Leaves Filter",
	filterType: 'type',
	options: [],
	selected: [],
	handleSelect: (value, type) => console.log(value, type),
	titleWidth: 'initial',
	titleFontSize: 1
};

export default DropdownField;
